<template>
  <div class="accordion">
    <ui-accordion-item
      v-for="item in items"
      :key="item.key"
      :item-key="item.key"
      :title="item.title"
      :content="item.description"
      :not-extendable="!extendable"
      @click.native="$emit('item-click', item.key)"
    >
      <template #title>
        <slot name="title" :data="item" />
      </template>

      <slot :data="item" />
    </ui-accordion-item>
  </div>
</template>

<script>
import UiAccordionItem from '@kit/ui-accordion/ui-accordion-item.vue';

export default {
  name: 'accordion',

  components: {
    UiAccordionItem,
  },

  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    extendable: {
      type: Boolean,
      default: false,
    }
  },
}
</script>
